<div>
    <div class="forget-container">
        <h6>Set new password</h6>
        <p>You have successfully recovered your account, please set a new password
            before logging into your account.</p>
    </div>
    <form [formGroup]="passwordResetForm">
        <div class="formGroup">
            <i (click)="isOldPasswordTextType = !isOldPasswordTextType">
                <div *ngIf="isOldPasswordTextType; else passwordVisible">
                    <collab-comp-img-generator imageType="icon" fontClassName="icon-View_Off" imageAltText="hide password"></collab-comp-img-generator>
                </div>
                <ng-template #passwordVisible>
                    <collab-comp-img-generator imageType="icon" fontClassName="icon-View_On" imageAltText="show password"></collab-comp-img-generator>
                </ng-template>
            </i>
            <div class="container__input--stacked margin__bottom--100">
                <label for="oldPassword" class="formGroup__title">Old Password</label>
                <input type="password"  class="input_field_login"  [type]="isOldPasswordTextType? 'password': 'text'" placeholder="Enter old password" formControlName="oldPassword" 
                [ngClass]="{
                    input__error: (passwordResetForm.get('oldPassword')?.touched || isFormSubmitted) &&
                    (passwordResetForm.get('newPassword')?.hasError('pattern')) 
                }"/>
                <app-form-inline-error [errorControlName]="convertToFormControl(passwordResetForm!.get('oldPassword'))"
                [messageConfig]="passwordResetErrors!.oldPassword"
                [isSubmitted]="isFormSubmitted"></app-form-inline-error>
            </div>
        </div>
        <div class="formGroup">
            <i (click)="isNewPasswordTextType = !isNewPasswordTextType">
                <div *ngIf="isNewPasswordTextType; else passwordVisible">
                    <collab-comp-img-generator imageType="icon" fontClassName="icon-View_Off" imageAltText="hide password"></collab-comp-img-generator>
                </div>
                <ng-template #passwordVisible>
                    <collab-comp-img-generator imageType="icon" fontClassName="icon-View_On" imageAltText="show password"></collab-comp-img-generator>
                </ng-template>
            </i>
            <div class="container__input--stacked margin__bottom--100">
                <label for="newPassword" class="formGroup__title">New Password</label>
                <input type="password" class="input_field_login" [type]="isNewPasswordTextType? 'password': 'text'" placeholder="Enter New password" formControlName="newPassword"
                [ngClass]="{
                    input__error: (passwordResetForm.get('newPassword')?.touched || isFormSubmitted) &&
                    (passwordResetForm.get('newPassword')?.hasError('pattern') || passwordResetForm.get('newPassword')?.hasError('minMax'))
                }"/>
                <app-form-inline-error [errorControlName]="convertToFormControl(passwordResetForm!.get('newPassword'))"
                [messageConfig]="passwordResetErrors!.newPassword"
                [isSubmitted]="isFormSubmitted"></app-form-inline-error>
            </div>

            <div class="formGroup">
                <i (click)="isConfirmPasswordTextType = !isConfirmPasswordTextType">
                    <div *ngIf="isConfirmPasswordTextType; else passwordVisible">
                        <collab-comp-img-generator imageType="icon" fontClassName="icon-View_Off" imageAltText="hide password"></collab-comp-img-generator>
                    </div>
                    <ng-template #passwordVisible>
                        <collab-comp-img-generator imageType="icon" fontClassName="icon-View_On" imageAltText="show password"></collab-comp-img-generator>
                    </ng-template>
                </i>
                <div class="container__input--stacked margin__bottom--100" *ngIf="passwordResetForm">
                    <label for="confirmPassword" class="formGroup__title">Confirm Password</label>
                    <input type="password" class="input_field_login" [type]="isConfirmPasswordTextType? 'password': 'text'" placeholder="Enter confirm password" formControlName="confirmPassword"
                    [ngClass]="{
                        input__error: (passwordResetForm.get('confirmPassword')?.touched || isFormSubmitted) &&
                        (passwordResetForm.get('confirmPassword')?.hasError('pattern') || passwordResetForm.get('confirmPassword')?.hasError('minMax'))
                    }"/>
                    <app-form-inline-error  [errorControlName]="convertToFormControl(passwordResetForm!.get('confirmPassword'))"
                    [messageConfig]="passwordResetErrors!.newPassword"
                    [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                </div>
                <div *ngIf="errors.length > 0 || isFormSubmitted" class="text_error">
                    <app-form-inline-error [errors]="errors" [isEmpty]="!isEmpty" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                  </div>                  
            </div>
            <collab-comp-button type="button" class="login-button " [buttonConfig]="loginButtonConfig"
            (click)="resetPassword()"></collab-comp-button>
      </div>
    </form>
    
</div>

<collab-comp-modal  [modalConfig]="passwordConfirmModal" (primaryButtonSelected)="closeModal()" (modalClosed)="closeModal()">
<div class="password-confirm-modal">
    <collab-comp-img-generator #success_password imageType="icon" fontClassName="icon-Success"></collab-comp-img-generator>
    <div>New password saved successfully!</div>
</div></collab-comp-modal>
